module.exports = __webpack_public_path__ + "static/media/ico-arrow-right-light.2ff77ed9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Pagination/ico-arrow-right-light.svg
// module id = 292
// module chunks = 0